import { render, staticRenderFns } from "./OnboardingSixthQuestion.vue?vue&type=template&id=fa15aa7e"
import script from "./OnboardingSixthQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingSixthQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports